import {
    inject,
    Injectable,
    Renderer2,
    RendererFactory2,
    signal,
} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageLockService {
    readonly #rf = inject(RendererFactory2);
    readonly #locked = signal(false);

    #lockEl: HTMLElement | null = null;
    #renderer: Renderer2;

    constructor() {
        this.#renderer = this.#rf.createRenderer(null, null);
    }

    enable() {
        if (this.#lockEl) return;
        this.#lockEl = this.#renderer.createElement('div');
        this.#lockEl!.className = 'page-lock';
        this.#renderer.appendChild(document.body, this.#lockEl);
        this.#locked.set(true);
    }

    disable() {
        if (!this.#lockEl) return;
        this.#renderer.removeChild(document.body, this.#lockEl);
        this.#lockEl = null;
        this.#locked.set(false);
    }
}
